/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Full_Permissions_Enabled_MessageInputs */



/**
* | output |
* | --- |
* | "Full permissions enabled. Users will have access to edit and create Event Groups." |
*
* @param {Team_Share_Full_Permissions_Enabled_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_full_permissions_enabled_message = /** @type {((inputs?: Team_Share_Full_Permissions_Enabled_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Full_Permissions_Enabled_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Autorisations complètes activées. Les utilisateurs pourront modifier et créer des groupes d’événements.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Berechtigungen sind aktiviert. Benutzer haben Zugriff auf die Bearbeitung und Erstellung von Ereignisgruppen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Autorizzazioni complete abilitate. Gli utenti avranno accesso per modificare e creare gruppi di eventi.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Полные права доступа предоставлены. Пользователи смогут редактировать и создавать группы событий.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Permisos completos habilitados. Los usuarios podrán editar y crear grupos de eventos.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已启用全部权限。用户可以编辑和创建活动组。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フル権限が有効です。ユーザーはイベントグループを編集および作成できます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पूर्ण अनुमतियाँ सक्षम कर दी गई हैं। उपयोगकर्ता इवेंट ग्रुप को संपादित और निर्मित कर सकेंगे।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Permissões totais ativadas. Os usuários terão acesso para editar e criar Grupos de Eventos.")
	return /** @type {LocalizedString} */ ("Full permissions enabled. Users will have access to edit and create Event Groups.")
});